// @ts-ignore
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export const DeliveryEstimateWidgetDocument = gql `
    query DeliveryEstimateWidget($offerId: ID!, $postcode: String!) {
  deliveryEstimate(offerId: $offerId, postcode: $postcode) {
    ... on DeliveryEstimateOfferSuccessResponse {
      offerId
      postcode
      deliveryEstimate {
        label
        labelType
        labelDescription
        shortLabel
        minRange
        maxRange
        timeStamp
        confidence
      }
    }
    ... on DeliveryEstimateOfferErrorResponse {
      offerId
      postcode
      error {
        code
        message
      }
    }
  }
}
    `;
/**
 * __useDeliveryEstimateWidgetQuery__
 *
 * To run a query within a React component, call `useDeliveryEstimateWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveryEstimateWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveryEstimateWidgetQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *      postcode: // value for 'postcode'
 *   },
 * });
 */
export function useDeliveryEstimateWidgetQuery(baseOptions) {
    return Apollo.useQuery(DeliveryEstimateWidgetDocument, baseOptions);
}
export function useDeliveryEstimateWidgetLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(DeliveryEstimateWidgetDocument, baseOptions);
}
export const LocationSuggestionsDocument = gql `
    query LocationSuggestions($searchTerm: String, $postcode: String, $suburb: String) {
  locationSuggestions(input: {postcode: $postcode, suburb: $suburb, searchParameters: {searchTerm: $searchTerm}}) {
    postcodes {
      id
      postcode
      suburb
      state
      stateCode
      country
    }
  }
}
    `;
/**
 * __useLocationSuggestionsQuery__
 *
 * To run a query within a React component, call `useLocationSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationSuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationSuggestionsQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      postcode: // value for 'postcode'
 *      suburb: // value for 'suburb'
 *   },
 * });
 */
export function useLocationSuggestionsQuery(baseOptions) {
    return Apollo.useQuery(LocationSuggestionsDocument, baseOptions);
}
export function useLocationSuggestionsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(LocationSuggestionsDocument, baseOptions);
}
export const UserLocationDocument = gql `
    query UserLocation($customerId: ID, $deviceId: String) {
  userLocation(customerId: $customerId, deviceId: $deviceId) {
    ... on UserLocationErrorResponse {
      customerId
      deviceId
      error {
        message
      }
    }
    ... on UserLocationSuccessResponse {
      customerId
      deviceId
      location {
        id
        postcode
        suburb
        state
        country
        geolocation {
          latitude
          longitude
        }
      }
    }
  }
}
    `;
/**
 * __useUserLocationQuery__
 *
 * To run a query within a React component, call `useUserLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserLocationQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      deviceId: // value for 'deviceId'
 *   },
 * });
 */
export function useUserLocationQuery(baseOptions) {
    return Apollo.useQuery(UserLocationDocument, baseOptions);
}
export function useUserLocationLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UserLocationDocument, baseOptions);
}
export const UpdateUserLocationDocument = gql `
    mutation UpdateUserLocation($input: UpdateUserLocationInput!) {
  updateUserLocation(input: $input) {
    ... on UpdateUserLocationErrorResponse {
      error {
        message
      }
    }
    ... on UpdateUserLocationSuccessResponse {
      location {
        id
        postcode
        suburb
        state
        country
        geolocation {
          latitude
          longitude
        }
      }
    }
  }
}
    `;
/**
 * __useUpdateUserLocationMutation__
 *
 * To run a mutation, you first call `useUpdateUserLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLocationMutation, { data, loading, error }] = useUpdateUserLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserLocationMutation(baseOptions) {
    return Apollo.useMutation(UpdateUserLocationDocument, baseOptions);
}
